module.exports = "<p>\n  exporter works!\n</p>\n"